export default __webpack_public_path__ + "f3fcd893369d76f97cd09630c3f13de6.png";